import { Crown } from "lucide-react";

export const GOLD = "#C9A84C";

export const LEVEL_META = {
  full: { label: "Full Access", short: "FULL", cls: "bg-[#C9A84C] text-[#0D0D0D] border-[#C9A84C]" },
  read: { label: "Read Only", short: "READ", cls: "bg-[#2A2A2A] text-[#F5F5F5] border-[#3A3A3A]" },
  none: { label: "No Access", short: "NONE", cls: "bg-transparent text-[#6B6B6B] border-[#2A2A2A]" },
};
const ORDER = ["full", "read", "none"];
export const nextLevel = (l) => ORDER[(ORDER.indexOf(l) + 1) % ORDER.length];

export function LevelPill({ level, testid, onClick, disabled, title }) {
  const m = LEVEL_META[level] || LEVEL_META.none;
  const base = `inline-flex items-center justify-center min-w-[58px] px-2 py-1 rounded-sm border text-[11px] font-grotesk uppercase tracking-[0.12em] transition-colors duration-200 ${m.cls}`;
  if (!onClick) return <span data-testid={testid} title={title || m.label} className={base}>{m.short}</span>;
  return (
    <button type="button" data-testid={testid} disabled={disabled} onClick={onClick} title={title || `${m.label} — click to change`}
      className={`${base} ${disabled ? "opacity-40 cursor-not-allowed" : "hover:border-[#C9A84C] cursor-pointer"}`}>{m.short}</button>
  );
}

export function LevelSelect({ value, onChange, testid, allowClear, disabled }) {
  return (
    <select data-testid={testid} value={value ?? ""} disabled={disabled} onChange={(e) => onChange(e.target.value || null)}
      className="bg-[#141414] border border-[#333333] text-[#F5F5F5] text-sm rounded-sm px-2 py-1.5 focus:border-[#C9A84C] outline-none disabled:opacity-40">
      {allowClear && <option value="">— Inherit from sub-role —</option>}
      <option value="full">Full Access</option>
      <option value="read">Read Only</option>
      <option value="none">No Access</option>
    </select>
  );
}

export function SectionHead({ title, kicker, action, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-5" data-testid={testid}>
      <div>
        {kicker && <div className="font-grotesk text-[10px] uppercase tracking-[0.3em] text-[#C9A84C] mb-1">{kicker}</div>}
        <h2 className="font-serif text-xl md:text-2xl text-[#F5F5F5]">{title}</h2>
      </div>
      {action}
    </div>
  );
}

export function GoldButton({ children, testid, className = "", ...rest }) {
  return (
    <button type="button" data-testid={testid} {...rest}
      className={`inline-flex items-center gap-2 rounded-sm bg-[#C9A84C] text-[#0D0D0D] px-4 py-2 text-sm font-semibold hover:bg-[#D9BC66] transition-colors duration-200 disabled:opacity-40 ${className}`}>
      {children}
    </button>
  );
}

export function GhostButton({ children, testid, className = "", danger, ...rest }) {
  const tone = danger ? "border-[#7A2E2E] text-[#E08A8A] hover:border-[#C0392B] hover:text-[#F5F5F5]" : "border-[#333333] text-[#D4D4D4] hover:border-[#C9A84C] hover:text-[#F5F5F5]";
  return (
    <button type="button" data-testid={testid} {...rest}
      className={`inline-flex items-center gap-2 rounded-sm border px-3 py-1.5 text-sm transition-colors duration-200 disabled:opacity-40 ${tone} ${className}`}>
      {children}
    </button>
  );
}

export const inputCls = "w-full bg-[#141414] border border-[#333333] text-[#F5F5F5] text-sm rounded-sm px-3 py-2 focus:border-[#C9A84C] outline-none placeholder:text-[#555]";

export function PioneerMark() {
  return <span className="inline-flex items-center gap-1.5 text-[#C9A84C]"><Crown size={14} /><span className="font-grotesk text-[10px] uppercase tracking-[0.3em]">The Pioneers</span></span>;
}

export const fmtTs = (ts) => ts ? new Date(ts).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
